export type MapPoint = { x: number; y: number };

export function movedBeyondClickTolerance(start: MapPoint | null, current: MapPoint, tolerance = 4): boolean {
  if (!start) return false;
  return Math.hypot(current.x - start.x, current.y - start.y) > tolerance;
}
